import React, {useEffect, useState} from 'react';
import {
    Spinner, 
    SpinnerSize
} from '@fluentui/react';

import StorefrontHeaderLinks from "./StorefrontHeaderLinks";
import StorefrontFooterLinks from "./StorefrontFooterLinks";
import Accordion from "../Common/Accordion";

interface StorefrontLinksEditorProps {
    isGlobal?: boolean;
    storefront?: string;
}

const StorefrontLinksEditor: React.FC<StorefrontLinksEditorProps> = (props) => {
    const [storefront, setStorefront] = useState<string>();
    
    useEffect(() => {
        setStorefront(props.isGlobal ? 'global' : props.storefront);
    },[props.isGlobal, props.storefront]);
    const [saving, setSaving] = useState(false);

    return (
        <div style={{width: '90%', minWidth: '300px'}}>
            {saving ? <Spinner label="Loading..." size={SpinnerSize.small} ariaLive="assertive"/> : <div style={{height: '44px'}}></div>}
            <Accordion beginExpanded={true} useChevron={true} title={'Header Links'}>
                <div style={{paddingLeft: '2em'}}>
                    <StorefrontHeaderLinks storefront={storefront ?? ""} isGlobal={props.isGlobal} saving={saving} onSaveEvent={(saving) => setSaving(saving)}/>
                </div>
            </Accordion>
            <Accordion beginExpanded={true} useChevron={true} title={'Footer Links'}>
                <div style={{paddingLeft: '2em'}}>
                    <StorefrontFooterLinks storefront={storefront ?? ""} isGlobal={props.isGlobal} saving={saving} onSaveEvent={(saving) => setSaving(saving)}/>
                </div>
            </Accordion>
        </div>
    );
};

export default StorefrontLinksEditor;
